import styled from '@emotion/styled';
import { Menu, MenuItem } from '@mui/material';
import { Text } from 'components';
import { colors } from 'styles/theme/colors';
export interface MenuOptionProps {
  label: string;
  endIcon?: JSX.Element;
  icon: JSX.Element;
  onClick: () => void;
}

interface ContextMenuProps {
  openMenu: boolean;
  options: MenuOptionProps[];
  onClose: () => void;
  menuPosition: { x: number; y: number };
}

export const ContextMenu = ({
  openMenu = false,
  options,
  onClose,
  menuPosition = { x: 0, y: 0 },
}: ContextMenuProps) => {
  const onMenuOptionClick = (event: React.MouseEvent<HTMLLIElement>) => {
    event.stopPropagation();
    onClose();
    const option = options.find(o => o.label === event.currentTarget.textContent);
    if (option) {
      option.onClick();
    }
  };
  return (
    <Menu
      onClose={onClose}
      open={openMenu}
      anchorPosition={{ top: menuPosition?.y, left: menuPosition?.x }}
      anchorEl={null}
      anchorReference="anchorPosition"
      MenuListProps={{ disablePadding: true }}
    >
      {options.map((option, index) => (
        <StyledMenuItem
          key={option.label}
          color={colors.grey[700]}
          sx={{
            ...(option.endIcon
              ? {
                  backgroundColor: '#EFF3F3',
                  fontWeight: 600,
                  '.MuiTypography-root': {
                    fontWeight: 600,
                  },
                }
              : {}),
          }}
          onClick={onMenuOptionClick}
        >
          {option.icon}
          <Text variant="labelSm" color="#4C4D4D">
            {option.label}
          </Text>
          {option.endIcon}
        </StyledMenuItem>
      ))}
    </Menu>
  );
};

const StyledMenuItem = styled(MenuItem)`
  display: flex;
  align-items: center;
  gap: 8px;
  height: 40px !important;
  padding: 6px 16px;
  &:hover {
    background-color: #eff3f3;
    .MuiTypography-root {
      font-weight: 600;
    }
  }
`;
